export enum TeamPageTabs {
  TeamMembers = 'Team Members',
  ManageTeams = 'Manage Teams',
  UrbanXTeam = 'URBAN X Team',
}
